import { createSelector } from "reselect";

const state = (state) => state.nationalInsights;

export const selectStateCount = createSelector([state], (data) => data.selectedStateCount);

export const selectCompareToggle = createSelector([state], (data) => data.compareToggle);

export const selectIntroModelToggle = createSelector([state], (data) => data.introModelToggle);
